import React, { useState, useEffect } from 'react';
import { postJson } from '../helpers/RequestsHelper'

const Vote = (props) => {

    const [votes, setVotes] = useState(props.votes ? props.votes : 0)
    const [voted, setVoted] = useState()

    useEffect(() => {
        setVotes(props.votes ? props.votes : 0);
    }, [props.votes]);

    const onVote = async (item) => {
        if (voted) {return}
        var path = process.env.REACT_APP_SERVER_BASE_URL + "/votes/" + props.type + "/" + props.docId
        await postJson(path, {})
        if (votes) {
            setVotes(votes + 1)
        } else {
            setVotes(1)
        }
        setVoted(true)
    }

    return <>
        <button onClick={onVote} className="btn btn-default icons-list-item"><i className="fa fa-thumbs-up"></i></button>Votes: {votes}
    </>
}

export default Vote